export default {
  id: 'teams_promote_jobs',
  title: 'Promote jobs',
  type: 'Direct',
  relations: [ 'MANY_JOBS' ],
  description: 'Send up to 4 selected jobs to your employees so they can easily share them across their network.',
  body: {
    attachments: [],
    body: {
      contentType: 'html',
      content: `
      <div>
        <p>[[INPUT_INTRODUCTION_TEXT]]</p>
        <BLOCK_JOB>
      </div>`.split('\n').map(line => line.trim().replaceAll('\n', '')).join(''),
    },
  },
  blocks: {
    BLOCK_JOB: id => `<attachment id='${id}'></attachment>`,
  },
  attachment: id => ({
    id,
    contentType: 'application/vnd.microsoft.card.adaptive',
    name: null,
    thumbnailUrl: null,
    contentUrl: null,
    content: JSON.stringify({
      type: 'AdaptiveCard',
      $schema: 'http://adaptivecards.io/schemas/adaptive-card.json',
      version: '1.4',
      body: [
        {
          type: 'ColumnSet',
          columns: [
            {
              type: 'Column',
              width: 1,
              items: [
                {
                  type: 'TextBlock',
                  text: '{{JOB_[ID]_TITLE}}',
                  wrap: true,
                  fontType: 'Default',
                  size: 'Large',
                  weight: 'Bolder'
                }
              ]
            }
          ]
        }
      ],
      actions: [
        {
          type: 'Action.OpenUrl',
          url: '{{JOB_[ID]_LINKEDIN_SHARE_LINK}}',
          title: '',
          iconUrl: 'https://real-links-assets-dev.s3-eu-west-2.amazonaws.com/real-links-WK80K/2023-12-06/01HGZ9V1JDSNHZZFC59WDMAYXS/screenshot-2023-12-06-at-11-07-22.png'
        },
        {
          type: 'Action.OpenUrl',
          title: 'LinkedIn Matches',
          style: 'positive',
          url: '{{JOB_[ID]_MATCH_LINK}}'
        }
      ]
    })
  }),
  inputs: {
    INPUT_INTRODUCTION_TEXT: {
      label: 'Intro',
      placeholder: 'Share the following jobs with your network to win rewards! ...',
      defaultValue: 'Share the following jobs with your network to win rewards!',
      type: 'HTML'
    }
  }
};


// WEBPACK FOOTER //
// ./src/views/campaign-admin/templates/teams/lnw/promoteJobs.js